STUDIP.ready(event => {
    STUDIP.i18n.init(event.target);
});
